import * as React from 'react';

interface AdminStatusBadgeProps {
  active: boolean;
  activeLabel: string;
  inactiveLabel: string;
  inactiveTone?: 'danger' | 'muted';
}

export function AdminStatusBadge({
  active,
  activeLabel,
  inactiveLabel,
  inactiveTone = 'muted',
}: AdminStatusBadgeProps) {
  if (active) {
    return (
      <span className="inline-flex items-center gap-1.5 text-[12px] font-medium text-emerald-700 dark:text-emerald-400">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
        {activeLabel}
      </span>
    );
  }

  return inactiveTone === 'danger' ? (
    <span className="inline-flex items-center gap-1.5 text-[12px] font-medium text-red-600 dark:text-red-400">
      <span className="w-1.5 h-1.5 rounded-full bg-red-500" />
      {inactiveLabel}
    </span>
  ) : (
    <span className="inline-flex items-center gap-1.5 text-[12px] font-medium text-muted-foreground">
      <span className="w-1.5 h-1.5 rounded-full bg-muted-foreground/40" />
      {inactiveLabel}
    </span>
  );
}
